import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";

export const FreeThrowIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { nsc, side, ...status } }) => {
    const normalizedNsc = String(nsc ?? "");
    const isFreeThrow = normalizedNsc === "1078" || normalizedNsc === "1079";

    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    if (!isFreeThrow) return null;

    const dy = 67.5; // (180 - 49) / 2 = 65.5 → around mid vertically

    return (
      <PathContainer className="free-throw-indicator">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 400 180"
          preserveAspectRatio="none"
        >
          <ellipse
            cx="33.5"
            cy="24.5"
            rx="33.5"
            ry="24.5"
            fill={fillColor}
            opacity={0.5}
            transform={
              String(side) === String(SIDE.HOME)
                ? `translate(${400 * 0.87} ${dy}) scale(-1 1)`
                : `translate(${400 * 0.13} ${dy})`
            }
          />
        </svg>
      </PathContainer>
    );
  }
);

const PathContainer = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  padding: 1vw;
  padding-bottom: 2vw;

  & > svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
